var _loading$upload;

import { createBrandName } from '../../utils/create';
var brandName = createBrandName().slice(0, -1);
export default (_loading$upload = {
  loading: '加载中'
}, _loading$upload[brandName + "Dialog"] = {
  cancel: '取消',
  confirm: '确定'
}, _loading$upload[brandName + "Picker"] = {
  cancel: '取消',
  confirm: '确定'
}, _loading$upload.upload = {
  exceedText: '文件超过限制，请重新上传'
}, _loading$upload[brandName + "DatetimePicker"] = {
  title: '选择时间',
  year: '年',
  month: '月',
  day: '日',
  hour: '时',
  minute: '分'
}, _loading$upload[brandName + "Calendar"] = {
  title: '选择时间',
  cancel: '取消',
  confirm: '确定',
  // template of month bar
  monthBar: '{year}年{month}月',
  // days of a week
  sunday: '日',
  monday: '一',
  tuesday: '二',
  wednesday: '三',
  thursday: '四',
  friday: '五',
  saturday: '六'
}, _loading$upload[brandName + "Field"] = {
  placeholder: '请输入内容'
}, _loading$upload);